export default function defaultResultsState() {
    return {
        questions:              [
            { id: '1.1', value: null },
            { id: '1.2', value: null },
            { id: '1.3', value: null },
            { id: '1.4', value: null },

            { id: '2.1', value: null },
            { id: '2.2', value: null },
            { id: '2.3', value: null },

            { id: '3.1', value: null },
            { id: '3.2', value: null },
            { id: '3.3', value: null },

            { id: '4.1', value: null },
            { id: '4.2', value: null },
            { id: '4.3', value: null },
            { id: '4.4', value: null },

            { id: '5.1', value: null },
            { id: '5.2', value: null },

            { id: '6.1', value: null },
            { id: '6.2', value: null },
            { id: '6.3', value: null },

            { id: '7.1', value: null },
            { id: '7.2', value: null },
            { id: '7.3', value: null },
            { id: '7.4', value: null },

            { id: '8.1', value: null },
            { id: '8.2', value: null },
            { id: '8.3', value: null },
            { id: '8.4', value: null },

            { id: '9.1', value: null },
            { id: '9.2', value: null },
            { id: '9.3', value: null },

            { id: '10.1', value: null },
            { id: '10.2', value: null },
            { id: '10.3', value: null },
            { id: '10.4', value: null },

            { id: '11.1', value: null },
            { id: '11.2', value: null },
            { id: '11.3', value: null },
            { id: '11.4', value: null },

            { id: '12.1', value: null },
            { id: '12.2', value: null },
            { id: '12.3', value: null },

            { id: '13.1', value: null },
            { id: '13.2', value: null },
            { id: '13.3', value: null },

            { id: '14.1', value: null },
            { id: '14.2', value: null },
            { id: '14.3', value: null },
            { id: '14.4', value: null },

            { id: '15.1', value: null },
            { id: '15.2', value: null },
            { id: '15.3', value: null },
            { id: '15.4', value: null },

            { id: '16.1', value: null },
            { id: '16.2', value: null },
            { id: '16.3', value: null },
            { id: '16.4', value: null },

            { id: '17.1', value: null },
            { id: '17.2', value: null },
            { id: '17.3', value: null },

            { id: '18.1', value: null },
            { id: '18.2', value: null },
        ],
    };
}
